// GVINFOX Theme — Main JavaScript

document.addEventListener('DOMContentLoaded', function () {

  // ---- Countdown Timer ----
  function startCountdown() {
    var timers = document.querySelectorAll('[data-countdown]');
    if (!timers.length) return;

    function getEndTime() {
      var now = new Date();
      var end = new Date();
      end.setHours(23, 59, 59, 0);
      if (now >= end) end.setDate(end.getDate() + 1);
      return end;
    }

    function updateTimer() {
      var now = new Date();
      var end = getEndTime();
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;

      timers.forEach(function (el) {
        var hEl = el.querySelector('[data-hours]');
        var mEl = el.querySelector('[data-minutes]');
        var sEl = el.querySelector('[data-seconds]');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
      });
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  startCountdown();

  // ---- Product Image Thumbnails ----
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.querySelector('.product-main-image img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.querySelector('img').src;
      }
    });
  });

  // ---- Add to Cart ----
  var addToCartForm = document.querySelector('[data-add-to-cart-form]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = addToCartForm.querySelector('[data-add-to-cart]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      var formData = new FormData(addToCartForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (btn) {
            btn.textContent = '✓ Added!';
            setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2000);
          }
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var countEls = document.querySelectorAll('.cart-count');
            countEls.forEach(function(el) { el.textContent = cart.item_count; });
          });
        })
        .catch(function () {
          if (btn) { btn.textContent = 'Error — Try Again'; btn.disabled = false; }
        });
    });
  }

  // ---- Remove Cart Item ----
  document.querySelectorAll('[data-remove-item]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-remove-item');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { location.reload(); });
    });
  });

  // ---- Back to Top ----
  var backBtn = document.getElementById('backToTop');
  if (backBtn) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) { backBtn.classList.add('visible'); }
      else { backBtn.classList.remove('visible'); }
    });
  }

  // ---- Fade In on Scroll ----
  var fadeEls = document.querySelectorAll('.fade-in');
  if (fadeEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(function (el) { observer.observe(el); });
  }

  // ---- Order Popup ----
  var names = [
    'Priya from Delhi', 'Rahul from Mumbai', 'Anjali from Bangalore',
    'Vikram from Pune', 'Sneha from Chennai', 'Amit from Jaipur',
    'Pooja from Hyderabad', 'Rohan from Kolkata', 'Kavita from Surat',
    'Arjun from Lucknow'
  ];

  var popup = document.getElementById('orderPopup');
  var popupTitle = document.getElementById('popupTitle');

  function showPopup() {
    if (!popup) return;
    var name = names[Math.floor(Math.random() * names.length)];
    if (popupTitle) popupTitle.textContent = name;
    popup.classList.add('show');
    setTimeout(function () { popup.classList.remove('show'); }, 4000);
  }

  // Show popup after 5s, then every 18s
  setTimeout(function () {
    showPopup();
    setInterval(showPopup, 18000);
  }, 5000);

  // ---- Shipping Progress Bar ----
  
  var progressStatus = document.querySelector('.shipping-progress-status');
  if (progressFill && progressStatus) {
    var cartTotal = parseInt(progressFill.getAttribute('data-total') || '0');
    var freeAt = 499;
    var pct = Math.min(100, Math.round((cartTotal / freeAt) * 100));
    progressFill.style.width = pct + '%';
    if (cartTotal >= freeAt) {
      progressStatus.textContent = '🎉 You got FREE delivery!';
    } else {
      var remaining = freeAt - cartTotal;
      progressStatus.textContent = 'Add ₹' + remaining + ' more for FREE delivery!';
    }
  }

});

// ---- Mobile Menu Toggle ----
function toggleMenu() {
  var menu = document.getElementById('mobileMenu');
  if (menu) menu.classList.toggle('open');
}

// ---- Close Popup ----
function closePopup() {
  var popup = document.getElementById('orderPopup');
  if (popup) popup.classList.remove('show');
}

// ---- Fix Price Display on Variant Change ----
function updatePrice(select) {
  var selectedOption = select.options[select.selectedIndex];
  var price = selectedOption.getAttribute('data-price');
  if (!price) return;

  var priceEl = document.querySelector('.product-price');
  if (priceEl && price) {
    var formatted = '₹' + (parseInt(price) / 100).toLocaleString('en-IN');
    priceEl.textContent = formatted;
  }
}

// ---- Fix Cart Price — ensure correct variant price sent ----
document.addEventListener('DOMContentLoaded', function () {
  var variantSelect = document.getElementById('variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      updatePrice(this);
    });
  }
});
